import {createSlice} from '@reduxjs/toolkit'

import {GlobalState} from '~/types/bussiness/global'

const initialState: GlobalState = {
  globalConfig: {
    OSType: 'web',
    theme: 'dark',
  },
}

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalConfigKey: (state, action) => {
      return {
        ...state,
        globalConfig: {
          ...state.globalConfig,
          [action.payload.key]: action.payload.value,
        },
      }
    },
  },
})
export default globalSlice.reducer
export const {setGlobalConfigKey} = globalSlice.actions
